module.exports = __webpack_public_path__ + "static/media/sf.f871e125.png";